<template>
    <HeaderAdmin />
    <div class="main_bottom_box">
        <SidebarAdmin />
        <TaskReport />
    </div>
</template>
<script>
import { createLocal } from 'the-storages'
import { BASE_URL } from "../config";
import axios from "axios";

const mirror = createLocal()
const storage = mirror._prx


import HeaderAdmin from "../components/AdminDashboard/HeaderAdmin.vue";

import SidebarAdmin from "../components/AdminDashboard/SidebarAdmin.vue";

import TaskReport from "../components/MarketingDashboard/TaskReport.vue";

export default {
    name: 'TaskAssignmentPage',
    components:{
        HeaderAdmin,
        SidebarAdmin,
        TaskReport
    },
    data() {
        return {
            storageData: mirror,
            storage: storage,
        }
    },
    methods :{

    },
    async created(){
        this.userName = mirror.USERNAME
   },
   beforeRouteEnter(to, from, next) {
    console.log(mirror);
        if (mirror.ADMIN_STATUS=='masteradmin') {
            next();
            console.log("next");
        }
        else {
            next('/adminDashboard');
            console.log("back");

        }
    }
}
</script>
<style scoped>
</style>